<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5" id="grad1">
          <!-- breadcrumb and title row starts -->
          <div class="row">
            <div class="col-sm-12 print-scr">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Trainee/traineeDashboard'
                  },

                  {
                    title: 'Trainee Questions',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
            </div>
            <!-- <div class="col-sm-12">
              <div class="heading mt-3">
                <h3 class="text-secondary">Training Wizard</h3>
              </div>
            </div> -->
          </div>
          <!-- breadcrumb and title row Ends -->
          <div class="row">
            <div class="col-md-12">
              <div></div>
              <div class="container mt-5">
                <div class="questionScreen d-flex flex-column">
                  <div class="d-flex  p-2">
                    <div class="training-code pr-2">
                      <h6 class="training-code-clr">T001</h6>
                    </div>
                    <div class="training-title">
                      <h6>
                        Inter Agency Training "Information Gathering & Analysis"
                      </h6>
                      <small>02/28/2020 - 02/29/2020</small>
                      <p>Peshawar,KPK</p>
                    </div>
                  </div>
                  <div class="pl-3 mb-2">
                    <h5>Pre Assessment</h5>
                  </div>
                  <div class="question pl-3">
                    <h6>Question 1 OFF 20</h6>
                    <p><b>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Adipiscing tristique risus nec feugiat in
                      fermentum. Amet purus gravida quis blandit turpis cursus
                      in ?
                      </b>
                    </p>
                  </div>
                  <div class="options ml-3">
                    <p><i>Click on the right option below</i></p>
                    <ul>
                      <li class="option-1">
                        <p class="mb-1">
                         <span class="pr-1">1)</span> Neque viverra justo nec ultrices dui.
                        </p>
                      </li>
                      <li class="option-2">
                        <p class="mb-1">
                          <span class="pr-1">2)</span> Neque viverra justo nec ultrices dui.
                        </p>
                      </li>
                      <li class="option-3">
                        <p class="mb-1">
                          <span class="pr-1">3)</span> Neque viverra justo nec ultrices dui.
                        </p>
                      </li>
                      <li class="option-4">
                        <p class="mb-1">
                         <span class="pr-1">4)</span> Neque viverra justo nec ultrices dui.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

export default {
  data: () => ({
    isSidebar: false,
    trainingCode: ""
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingCode = this.$route.query.trainingId;
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    printReport: function() {
      window.print();
    }
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
.questionScreen{
  border: 1px solid #fff0a2;
  background-color:#fffae5;
  box-shadow: 0 1px 5px 0 rgba(0,0,0,.1);
}
.training-code-clr{
  color:#eadb89;
}
.question h6{
  text-decoration: underline;

}
</style>
